import { computed } from 'vue';

export function useComponentProps(props, emit, propNames) {
    const result = {};
    for (const name of propNames) {
        result[name] = computed({
            get: () => props[name],
            set: (val) => emit(`update:${name}`, val),
        });
    }
    return result;
}
